import Card from '../../../UI/MDC/Card/Card';
import { Headline6 } from '@material/react-typography';

import classes from '../../../UI/GenericForm/GenericForm.module.scss';

const STYLE_CARD_DEFAULT = 'mdc-card--app'; //TODO:  move this to external file

const submittedApp = props => {
	return (
		<Card xlarge className={classes[STYLE_CARD_DEFAULT]} submitted>
			<Headline6>
				Please fill in any missing information for the other
				applications you are requesting and click submit to complete
				this request.
			</Headline6>
		</Card>
	);
};

export default submittedApp;
